/** Kurzes Konfetti-Overlay (Canvas). Nutzt die Antwortfarben des Themes. */
export function burstConfetti(durationMs = 3000): void {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  const cs = getComputedStyle(document.documentElement);
  const colors = ['--opt-1', '--opt-2', '--opt-3', '--opt-4', '--opt-5', '--opt-6', '--accent']
    .map((v) => cs.getPropertyValue(v).trim())
    .filter(Boolean);
  if (colors.length === 0) colors.push('#3b7ff5', '#22d3a6', '#ff922b');

  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:60';
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);
  const g = canvas.getContext('2d')!;

  const N = 160;
  const parts = Array.from({ length: N }, () => ({
    x: Math.random() * canvas.width,
    y: -20 - Math.random() * canvas.height * 0.3,
    r: 4 + Math.random() * 6,
    vx: -2 + Math.random() * 4,
    vy: 2 + Math.random() * 4,
    rot: Math.random() * Math.PI,
    vr: -0.2 + Math.random() * 0.4,
    color: colors[Math.floor(Math.random() * colors.length)]!,
  }));

  const start = performance.now();
  function frame(now: number) {
    const elapsed = now - start;
    g.clearRect(0, 0, canvas.width, canvas.height);
    for (const p of parts) {
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.05;
      p.rot += p.vr;
      g.save();
      g.translate(p.x, p.y);
      g.rotate(p.rot);
      g.fillStyle = p.color;
      g.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 0.6);
      g.restore();
    }
    if (elapsed < durationMs) requestAnimationFrame(frame);
    else canvas.remove();
  }
  requestAnimationFrame(frame);
}
